<template>
  <div v-if="show" class="chart-wrap">
    <div class="chart-block">
      <chartPie
        class="wait-chart"
        :NO="1"
        title="新增客户会员等级分析"
        @source="data_source"
        textTip="等级分析"
        colorKey="yellow"
        :data="level"
      ></chartPie>
    </div>
    <div class="chart-block">
      <chartPie
        class="wait-chart"
        :NO="2"
        title="新增客户用户规模分析"
        @source="data_source"
        textTip="规模分析"
        colorKey="orange"
        :data="size"
      ></chartPie>
    </div>
    <div class="chart-block">
      <chartPie
        ref="vvv"
        :NO="3"
        class="wait-chart"
        title="新增客户所属行业分析"
        @source="data_source"
        textTip="行业分析"
        colorKey="blue"
        :data="industry"
      ></chartPie>
    </div>
  </div>
</template>
<script>
import chartPie from "@/components/pie.vue";
export default {
  components: {
    chartPie
  },
  props: {
    show: Boolean,
    data:{
      default:{
        
      }
    }
  },
  data() {
    return {
      chartlist: [],
    };
  },
  computed:{
            // 新增客户会员等级分析
            level(){
                return this.data.level || [];
            },
            // 新增客户用户规模分析
            size(){
                return this.data.size || [];
            },
            // 新增客户所属行业分析
            industry(){
                return this.data.industry || [];
            },
  },
  methods:{
      data_source(data,NO){
                this.chartlist[NO-1]=data
                
                let that=this
              
                    window.onresize  = function () {
                        for (let index = 0; index < that.chartlist.length; index++) {
                          that.$func.addwindowsonresize(that.chartlist[index].resize)
                        }
                    }
            }
  }
};
</script>
<style lang="less" scoped>
    @space:15px;
    // *****图表
    .chart-wrap{
        margin-right: 15px;
        .clear();
        .chart-block{
            float: left;
                margin-left: @space;
                box-sizing: border-box;
                width: calc(~'33.333% - 15px');
                background: #fff;
            .wait-chart{
                width: 100%;
                background: #fff;
                height:330px;
            }
        }
        
    }
</style>
